exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  border: 4px solid #dddddd;\n  border-top: 4px solid #666666;\n  border-right: 4px solid #666666;\n  border-left: 4px solid #666666;\n  border-radius: 50%;\n  margin: 20px auto;\n  animation: spin 1.5s linear infinite;\n}\n@keyframes spin {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
